import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { NewlyCalculatedGADDetails } from "./CalculatedGADDetails";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ChooseAssetsToSell } from "../Shared/ChooseAssetsToSell";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import {
    getAssetsToSellTotalForDrawdown,
    getSellableAssetsAfterSwitch,
    getUpdatedAssetsToSell,
    showChooseAssetstoSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { RegularIncomePaymentDetails } from "./RegularIncomePaymentDetails";
import { OtherIncomePaymentDetails } from "./OtherIncomePaymentDetails";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { IncomeBankDetails } from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { BuyAction } from "../../../Buy/Action/BuyAction";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { SecurityType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { DrawdownIncomeAmendmentInstruction } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownIncomeAmendmentInstruction";
import { DrawdownAnnualIncome } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownAnnualIncome";
import _, { isEmpty } from "lodash";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { TableKeys } from "../../../Common/SIPP/DrawdownDetails/Resource/Constant";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";

interface IIncomePaymentDetailsProps extends IProcessComponentProps {
    data: PensionContributionModel;
    type: SubAccountType;
}

interface IIncomePaymentDetailsState {
    assets: ChooseAssetsToSellAssets[];
    accountHasETIholdings: Boolean;
    isAcrossAllAssets: boolean;
}

export class IncomePaymentDetails extends ProcessComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            assets: [],
            accountHasETIholdings: false,
            isAcrossAllAssets: true,
        };
    }

    private getSellableAssets = () => {
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        const switchInstruction = this.props.data?.Contribution?.DrawdownModel?.SwitchInstructionModel;
        SubAccountTypeHelper.getSubAccountHierarchyId(hierarchyId, SubAccountType.Npr, (subAccountHierarchyId) => {
            getSellableAssetsAfterSwitch(this.props.type, hierarchyId, subAccountHierarchyId, switchInstruction, (data) => {                                
                const usedTotal = getAssetsToSellTotalForDrawdown(this.props.data?.Contribution?.DrawdownModel);          
                const updateAssets = getUpdatedAssetsToSell(
                    this.props.data?.Contribution?.DrawdownModel.PensionCommencementLumpSumAllocations,
                    usedTotal,
                    data.assetsToSell.filter((ele) => ele.ProductType != ProductType.OffPlatform)
                );
                this.setState({ assets: updateAssets });
            });
            BuyAction.getReuseHoldings(hierarchyId, subAccountHierarchyId, 0, (result: ClientTradableInvestments) => {
                if (!result?.CurrentIndividualHoldings) {
                    return;
                }
                for (let holding of result.CurrentIndividualHoldings) {
                    if (holding.SecurityType === SecurityType.Bond || holding.SecurityType === SecurityType.Share) {
                        this.setState({ accountHasETIholdings: true });
                        break;
                    }
                }
            })
        });
    };

    componentDidMount() {
        super.componentDidMount();
        this.getSellableAssets();

        const assets = this.props.data.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations;
        if (!isNullOrEmpty(assets)) {
            this.setState({ isAcrossAllAssets: false });
        }
    }

    componentDidUpdate(prevProps: any): void {
        super.componentDidUpdate(prevProps);
        if (prevProps.data.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations
            !== this.props.data.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations) {
            // if IsAcrossAllAssets set to true, then allocation is calculated by backend, so list should be empty
            const assets = this.props.data.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations;
            if (!isNullOrEmpty(assets)) {
                this.setState({ isAcrossAllAssets: false });
            }
        }
    }

    private getContributionProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution,
            onChange: (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private getDrawdownModelProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private onAnnualIncomeChange = (drawdownModelAnnualIncome: DrawdownAnnualIncome, amendmendModelAnnualIncome: DrawdownAnnualIncome) => {
        const { data, onChange } = this.props;
        var clonedContribution = _.cloneDeep(data.Contribution)

        if (drawdownModelAnnualIncome) {
            clonedContribution.DrawdownModel.Income = drawdownModelAnnualIncome
        }

        if (amendmendModelAnnualIncome) {
            clonedContribution.DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction.Income = amendmendModelAnnualIncome
        }

        onChange({ Contribution: clonedContribution });
    }

    private onDrawdownIncomeAmendmentInstructionChange = (changes: DrawdownIncomeAmendmentInstruction) => {
        const { data, onChange } = this.props;
        this.onDataChange(
            (v) => this.onDataChange(onChange, v, data, "Contribution"),
            changes,
            data.Contribution,
            "DrawdownIncomeAmendmentModel"
        )
    };

    showChooseAssetsToSellTable() : boolean {
        return !this.state.isAcrossAllAssets;
    }

    private onIncomeReviewChange(changes) {
        const { data, onChange } = this.props;
        this.onDataChange(
            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
            changes,
            data.Contribution,
            "DrawdownIncomeReviewDetails"
        )
    }

    private handleIncomePaymentAllocationsChange(value) {
        const { data, onChange } = this.props;
        const contribution = data?.Contribution || {};

        var updatedContribution = _.cloneDeep(contribution);

        if (updatedContribution.DrawdownModel?.Income?.IncomePaymentAllocations) {
            updatedContribution.DrawdownModel.Income.IncomePaymentAllocations = value;
        }

        if (updatedContribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.Income?.IncomePaymentAllocations) {
            updatedContribution.DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction.Income.IncomePaymentAllocations = value;
        }

        this.onDataChange(
            onChange,
            updatedContribution,
            data,
            "Contribution"
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const drawdownType = data?.Contribution?.DrawdownModel?.DrawdownType;
        
        return (
            <>
                {<h2>Income payment details</h2>}

                {<h3>Set income payment</h3>}

                {!(data?.Contribution?.DrawdownModel?.ITFCRequestId && data?.Contribution?.DrawdownModel?.TaxFreeLumpSum?.Amount > 0) && <>
                    {drawdownType === DrawdownType.Capped && (
                        <NewlyCalculatedGADDetails {...this.getContributionProps(data, onChange)} />
                    )}
                    {drawdownType === DrawdownType.Regular ? (
                        <RegularIncomePaymentDetails {...this.getDrawdownModelProps(data, onChange)} pensionBase={data.Contribution} sellableAssets={this.state.assets}/>
                    ) : (
                        <OtherIncomePaymentDetails 
                            {...this.getDrawdownModelProps(data, onChange)}
                            onAnnualIncomeChange={(c, v) => this.onAnnualIncomeChange(c, v)}
                            onDrawdownIncomeAmendmentInstructionChange={(changes) => this.onDrawdownIncomeAmendmentInstructionChange(changes)}
                            pensionBase={data.Contribution}
                            drawdownIncomeReviewDetails={data?.Contribution?.DrawdownIncomeReviewDetails}
                            onIncomeReviewChange={(changes) => this.onIncomeReviewChange(changes)}
                            allBankAccounts={data.AllBankAccounts}
                            bankAccountInstructions={data?.BankAccountInstructions}
                            sellableAssets={this.state.assets}
                        />
                    )}
                    {showChooseAssetstoSell(data.Contribution.DrawdownModel, ChooseAssetsToSellFor.Income) &&
                        data?.Contribution?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition && (
                            <>
                                <hr />
                                <ChooseAssetsToSell
                                    {...this.getDrawdownModelProps(data, onChange)}
                                    tableKey={TableKeys.IncomeDisinvestmentAllocations}
                                    reason={ChooseAssetsToSellFor.Income}
                                    accountHasETIHoldings={this.state.accountHasETIholdings}
                                    assets={this.state.assets}
                                    pensionBase={this.props?.data?.Contribution}
                                    isAcrossAllAssets={this.state.isAcrossAllAssets}
                                    setIsAcrossAllAssets={(v) => this.setState({ isAcrossAllAssets: v })}
                                />
                                {this.showChooseAssetsToSellTable() && (
                                    <ChooseAssetsToSellTable
                                        data={data?.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations}
                                        tableData={this.state.assets}
                                        modelData={data?.Contribution?.DrawdownModel}
                                        onRef={(ref) => this.appendChild(ref)}
                                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                        onChange={(v) => {
                                            this.onDataChange(
                                                (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                                { IncomeDisinvestmentAllocations: v },
                                                data.Contribution,
                                                "DrawdownModel"
                                            );
                                        }}
                                        processType={ProcessType.TakePensionBenefits}
                                        reason={ChooseAssetsToSellFor.Income}
                                        isAcrossAllAssets={data?.Contribution?.DrawdownModel?.IsAcrossAllAssets}
                                        disableOffPlatform={true}
                                        pensionBase={this.props?.data?.Contribution}
                                    />
                                )}
                                <hr />
                            </>
                        )}
                </>}
                <IncomeBankDetails
                    data={data?.Contribution?.DrawdownModel?.Income?.IncomePaymentAllocations || []}
                    onChange={(value) => {
                        this.handleIncomePaymentAllocationsChange(value);
                    }}
                    onPaymentMethodChange={(value) => {
                        if (data.Contribution?.DrawdownModel?.Income) {
                            data.Contribution.DrawdownModel.Income.PaymentMethod = value;
                        }
                        onChange(data);
                    }}
                    showErrorMsgPopUp={(msg, isShow) => this.props.showErrorMsgPopUp(msg, isShow)}
                    onRef={(ref) => this.appendChild(ref)}
                    bankAccountInstructions={data?.BankAccountInstructions}
                    allBankAccounts={data?.AllBankAccounts}
                    showPropotionOfIncome={data?.Contribution?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition}
                    showPropotionOfPcls={true}
                    drawdownType={data?.Contribution?.DrawdownModel?.DrawdownType}
                    onChangeBankAccountInstructions={(changes) => {
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }}
                    OwnerHierarchyId={data?.OwnerHierarchyId}
                />
            </>
        );
    }
}
